import { StyledSystemProps } from 'types/types'

const basicColors = {
  success: '#6BD39B',
  warning: '#EB5757',
  royalPruple: '#7643A1',
  purpleHeart: '#6541B7',
  blueViolet: '#4E32B6',
  darkBlueViolet: '#4036A3',
  stPatricksBlue: '#432778',
  oxfordBlue: '#002548',
  sugarCrystal: '#F6F5FF',
  electricBlue: '#64ECFF',
  theLotusBlue: '#3BB4FF',
  mediumAquamarine: '#6BD39B',
  persianPink: '#FF8BD1',
  mustard: '#FFDF45',
  lavenderBlue: '#EDE6F5'
}

const gray = {
  0: '#F6F5FF',
  100: '#DFE0E2',
  200: '#C5C6CA',
  300: '#AAADB2',
  400: '#8F939A',
  500: '#757981',
  600: '#696C74',
  700: '#414348',
  800: '#313336',
  900: '#141414'
}

const white = {
  100: 'rgba(255, 255, 255, 1)',
  80: 'rgba(255, 255, 255, 0.8)',
  72: 'rgba(255, 255, 255, 0.72)',
  64: 'rgba(255, 255, 255, 0.64)',
  48: 'rgba(255, 255, 255, 0.48)',
  40: 'rgba(255, 255, 255, 0.4)',
  32: 'rgba(255, 255, 255, 0.32)',
  24: 'rgba(255, 255, 255, 0.24)',
  16: 'rgba(255, 255, 255, 0.16)',
  '08': 'rgba(255, 255, 255, 0.08)',
  0: 'rgba(255, 255, 255, 0.0)'
}

const black = {
  100: 'rgba(0, 0, 0, 1)',
  80: 'rgba(0, 0, 0, 0.8)',
  72: 'rgba(0, 0, 0, 0.72)',
  64: 'rgba(0, 0, 0, 0.64)',
  48: 'rgba(0, 0, 0, 0.48)',
  40: 'rgba(0, 0, 0, 0.4)',
  32: 'rgba(0, 0, 0, 0.32)',
  24: 'rgba(0, 0, 0, 0.24)',
  16: 'rgba(0, 0, 0, 0.16)',
  '08': 'rgba(0, 0, 0, 0.08)',
  0: 'rgba(0, 0, 0, 0.0)'
}

const mainColors = {
  primary: {
    light: {
      100: '#EDE6F5',
      200: '#F2ECFB'
    },
    main: '#432778',
    dark: {
      100: '#623AB2',
      200: '#432778'
    }
  },
  secondary: {
    light: {
      100: '#B199DB',
      200: '#9777CF'
    },
    main: '#623AB2',
    dark: {
      100: '#593498',
      200: '#3E246A'
    }
  }
}

const colors = {
  gray,
  white,
  black,
  ...basicColors,
  ...mainColors
}

export type SingleColorOptions =
  | ''
  | 'transparent'
  | keyof typeof basicColors
  | `gray.${keyof typeof gray}`
  | `white.${keyof typeof white}`
  | `black.${keyof typeof black}`
  | `${keyof typeof mainColors}.${
      | 'main'
      | `${'light' | 'dark'}.${'100' | '200'}`}`

export type ColorOptions = StyledSystemProps<SingleColorOptions>

export default colors
